<template>
    <div id="modal-holder">
        <ModalCreateProject/>
        <ModalEditProject/>
        <ModalDeletePhoto/>
        <ModalCopyProject/>
        <ModalDeleteProject/>
        <ModalAddPhoto/>
        <ModalShowPhotoInResult/>
<!--        <ModalProfile/>-->
        <modals-container/>
    </div>
</template>

<script>
    import ModalCreateProject from "./ModalCreateProject.vue";
    import ModalEditProject from "./ModalEditProject.vue";
    import ModalDeletePhoto from "./ModalDeletePhoto.vue";
    import ModalCopyProject from "./ModalCopyProject.vue";
    import ModalDeleteProject from "./ModalDeleteProject.vue";
    import ModalAddPhoto from "./ModalAddPhoto.vue";
    import ModalShowPhotoInResult from "./ModalShowPhotoInResult.vue";
    import ModalProfile from "./ModalProfile";

    export default {
        name: "TheModal",
        components: {
            ModalProfile,
            ModalShowPhotoInResult,
            ModalAddPhoto,
            ModalDeleteProject,
            ModalCopyProject,
            ModalDeletePhoto,
            ModalEditProject,
            ModalCreateProject
        }
    }
</script>
